import React from 'react';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import WarningIcon from '@mui/icons-material/Warning';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

import { setBundlesToShow } from '../../../store/batchesAndBundlesTabSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';

export function FilterToBundlesWithWarningsButton() {
  const dispatch = useAppDispatch();
  const bundlesToShow = useAppSelector((state) => state.batchesAndBundlesTab.bundlesToShow);

  return (
    <ToggleButtonGroup
      value={bundlesToShow}
      exclusive
      onChange={() => void dispatch(setBundlesToShow(bundlesToShow === 'All' ? 'BundlesWithWarnings' : 'All'))}
    >
      <ToggleButton value="All" size="small">
        <FilterAltOffIcon />
      </ToggleButton>
      <ToggleButton value="BundlesWithWarnings" size="small">
        <FilterAltIcon />
        <WarningIcon />
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
